import { isActionButtonV2 } from 'copilot-plugins/plugins/workflowsGenerateActionsPlugin/utils/messageUtils';
const separateOutActionButtons = actionButtons => {
  const previewButton = actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons.find(button => isActionButtonV2(button) && button.payload.intent === 'preview');
  const applyButton = actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons.find(button => isActionButtonV2(button) && button.payload.intent === 'save');
  const regenerateButton = actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons.find(button => isActionButtonV2(button) && button.payload.intent === 'refine');
  const otherButtons = actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons.filter(button => !isActionButtonV2(button) || button.payload.intent !== 'preview' && button.payload.intent !== 'save' && button.payload.intent !== 'refine');
  return {
    applyButton,
    otherButtons,
    previewButton,
    regenerateButton
  };
};
export const extractActionButtons = message => {
  const sections = message === null || message === void 0 ? void 0 : message.sections;
  if (!sections) {
    return undefined;
  }
  const actionSection = sections.find(section => section.type === 'ACTION');
  if (!(actionSection !== null && actionSection !== void 0 && actionSection.actions) || !Array.isArray(actionSection.actions)) {
    return undefined;
  }
  return separateOutActionButtons(actionSection.actions);
};